import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { TripBookingForm } from '../components/tripBooking/TripBookingForm.tsx'

export const TripBookingPage: React.FC = () => {
    const [searchParams] = useSearchParams()
    const apiKey = searchParams.get('pk')

    if (!apiKey) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <p className="text-gray-500 text-lg">Invalid or missing API key.</p>
            </div>
        )
    }

    return <TripBookingForm apiKey={apiKey} />
}
